(function ($) {
  DJ.addBehavior('stickyMenu', '.sticky-menu', {
    attach: function () {
      $(window).on('load', () => {
        const menu = this;
        const menuContainer = document.querySelector(
          '.js-sticky-menu-container'
        );
        const header = document.querySelector('.header__sticky-container');
        let currentBreakpoint = DJ.bp.name;

        /**
         * Return false if no menu container or header.
         */
        if (!menuContainer || !header) {
          return false;
        }

        /**
         * Set styles for an element.
         * @param element
         *  Element for which need to set styles.
         * @param {Object} styles
         *  Object with the styles to set.
         */
        const setStylesOnElement = (element, styles) => {
          Object.assign(element.style, styles);
        };

        /**
         * Toggle fixed position for the menu to emulate a sticky behavior
         * inside the needed container.
         */
        const toggleFixedPosition = () => {
          const menuContainerTop = menuContainer.offsetTop;
          const menuContainerHeight = menuContainer.offsetHeight;
          const headerBottom = header.offsetTop + header.offsetHeight + 23;

          if (DJ.bp.name === 'desktop' || DJ.bp.name === 'desktopBig') {
            if (window.pageYOffset + headerBottom >= menuContainerTop) {
              setStylesOnElement(menu, {
                position: 'fixed',
                top: `${headerBottom}px`,
              });
            } else {
              setStylesOnElement(menu, {
                position: 'absolute',
                top: '',
              });
            }
            if (
              window.pageYOffset + headerBottom + menu.offsetHeight
              >= menuContainerTop + menuContainerHeight
            ) {
              setStylesOnElement(menu, {
                position: 'absolute',
                top: 'auto',
                bottom: '23px',
              });
            }
          } else {
            setStylesOnElement(menu, {
              position: '',
              top: '',
            });
          }
        };

        /**
         * Call toggleFixedPosition() on window scroll.
         */
        window.addEventListener('scroll', () => {
          toggleFixedPosition();
        });

        /**
         * Call toggleFixedPosition() on window resize.
         */
        window.addEventListener('resize', () => {
          toggleFixedPosition();
        });

        /**
         * Close dropdown on breakpoint change.
         */
        DJ.on('changeBreakpoint', function () {
          setTimeout(function () {
            if (currentBreakpoint !== DJ.bp.name) {
              toggleFixedPosition();
              currentBreakpoint = DJ.bp.name;
            }
          }, 500);
        });

        return toggleFixedPosition();
      });
    },
  });
})(jQuery);
